import React from 'react'
import '../Styles/TermsPage.css'

function TermsPage() {
  return (
    <div className="tos-container">
      <h1>Terms of Service for BeRealTimelapse</h1>
      <p1><strong>Effective Date:</strong> 12/30/2024 </p1>
      <br></br>

      <p1>
        Welcome to BeRealTimelapse (“we,” “our,” or “us”). By accessing or
        using our services, you agree to comply with and be bound by these
        Terms of Service (“Terms”). If you do not agree to these Terms, you
        must not use our services.
      </p1>

      <h2>1. Eligibility</h2>
      <p1>
        By using the BeRealTimelapse services, you represent and warrant that:
      </p1>
      <ul>
        <li>You are at least 13 years old. If you are under the age of 18 or considered a minor in your jurisdiction, you have received permission from your parent or legal guardian to use our services.</li>
        <li>You have the legal capacity to agree to these Terms and comply with them.</li>
        <li>You will not access or use the service for any unlawful or unauthorized purposes.</li>
        <li>You will not access the service through automated or non-human means, such as a bot or script.</li>
      </ul>

      <h2>2. User Responsibilities</h2>
      <p1>You agree not to upload any content that:</p1>
      <ul>
        <li>Violates copyright, privacy rights, or applicable laws.</li>
        <li>Is illegal, harassing, hateful, harmful, defamatory, obscene, bullying, abusive, discriminatory, threatening, sexually explicit, false, inaccurate, deceitful, or misleading.</li>
      </ul>

      <p1>
        You are responsible for ensuring that you have the legal right to
        upload all data you submit to our service.
      </p1>

      <h2>3. Service Usage</h2>
      <p1>
        BeRealTimelapse is a platform designed for personal, non-commercial
        use unless otherwise agreed upon. Users may upload their data to create
        timelapse videos. The service does not store any personal information or
        user content permanently and deletes all uploaded data and timelapse
        videos after they are downloaded or within 7 days, whichever comes first.
      </p1>

      <h2>4. Limitation of Liability</h2>
      <p1>
        To the fullest extent permitted by law:
      </p1>
      <ul>
        <li>
          BeRealTimelapse and its owners, employees, and agents shall not be
          liable for any direct, indirect, incidental, special, or
          consequential damages arising from your use of the service.
        </li>
        <li>
          The service is provided "as is" without warranties of any kind,
          whether express or implied, including but not limited to fitness for
          a particular purpose or non-infringement.
        </li>
      </ul>

      <h2>5. Intellectual Property</h2>
      <p1>
        All intellectual property related to the BeRealTimelapse service,
        including but not limited to software, design, and content, is owned by
        BeRealTimelapse or its licensors. Users may not copy, distribute, or
        create derivative works from the service without explicit permission.
      </p1>

      <h2>6. Prohibited Activities</h2>
      <p1>Users may not:</p1>
      <ul>
        <li>Attempt to interfere with or disrupt the service’s functionality.</li>
        <li>Use the service for unlawful or unauthorized purposes.</li>
        <li>Misrepresent or misuse the service to harm others.</li>
      </ul>

      <h2>Contact Us</h2>
      <p1>
        If you have any questions about these Terms or the service, please contact us at:
      </p1>
      <p1><strong> contact@berealtimelapse.com </strong></p1>
    </div>
  )
}

export default TermsPage;